import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'flowaccount-tax-invoice-benefit',
  templateUrl: './tax-invoice-benefit.component.html',
  styleUrls: ['./tax-invoice-benefit.component.scss']
})
export class TaxInvoiceBenefitComponent implements OnInit {
  public textArrayLeft = new Array(4)
  public textArrayRight = new Array(4)
  constructor(public translate: TranslateService) { }

  ngOnInit(): void {
  }

}
